import { FC } from 'react';
import { ActionLogItem } from '@mews-commander/types';
import { DefaultErrorBoundary, LocalizedParagraph } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { useActionLogData } from '../data';
import { ActionLogItemRow } from './ActionLogItemRow';

interface ActionLogItemListProps {
    actionLogItems: ActionLogItem[];
}

const ActionLogItemList: FC<ActionLogItemListProps> = ({ actionLogItems = [] }) => {
    const actionLogData = useActionLogData();

    return (
        <>
            {actionLogItems.length !== 0 ? (
                actionLogItems.map((actionLogItem) => (
                    <DefaultErrorBoundary key={actionLogItem.id}>
                        <ActionLogItemRow actionLogItem={actionLogItem} actionLogData={actionLogData} />
                    </DefaultErrorBoundary>
                ))
            ) : (
                <Stack alignment="center">
                    <LocalizedParagraph textKey={TextKey.NoActionLogItems} />
                </Stack>
            )}
        </>
    );
};

export default ActionLogItemList;
